module.exports = "<div  [style.max-width.px]=\"width\"\r\n[style.font-size.px]=\"fontSize\">{{ text }}</div>"